import { Typography } from '@sunwebgroup/uds-ui/typography'
import * as React from 'react'
import styles from './HighlightedPaymentMethod.module.css'

interface HighlightedPaymentMethodProps {
  icon?: string
  text?: string
}

export function HighlightedPaymentMethod({ icon, text }: HighlightedPaymentMethodProps) {
  if (!icon || !text) {
    return null
  }

  return (
    <Typography as="div" className={styles.wrapper}>
      <img className={styles.paymentMethodImg} src={icon} alt={text} />
      {text}
    </Typography>
  )
}
